// Customer-facing Gitea issue templates. Single source of truth for both the
// React form renderer and the backend body composer — keep this file pure data
// + types so it can be safely imported on either side without pulling in any
// runtime dependencies.
//
// The internal "Testing" template that exists on the Gitea side is deliberately
// excluded; the portal only surfaces customer-applicable types.
// Label constants — these exact strings already exist in the client's Gitea,
// so the label-provisioning code must match them verbatim. Do not introduce
// the legacy `type:*` / `severity:*` strings here.
export const PORTAL_SUBMITTED_LABEL = 'portal-submitted';
export const CUSTOMER_LABEL_PREFIX = 'customer:'; // customer:<companySlug>
export const ISSUE_TYPES = {
    bug: {
        id: 'bug',
        // No emoji in `name` — customer-facing UI labels use lucide icons
        // (IssueTypeBadge in the frontend). `titlePrefix` retains the emoji
        // because the portal must match the client's Gitea template titles
        // verbatim — see the emoji-asymmetry test in this package.
        name: 'Bug Report',
        titlePrefix: '🐛 [BUG]: ',
        labels: ['Kind/Bug'],
        fields: [
            {
                id: 'problem',
                label: 'Problem',
                kind: 'textarea',
                required: true,
            },
            {
                id: 'steps-to-reproduce',
                label: 'Steps to reproduce',
                kind: 'textarea',
                required: true,
            },
            {
                id: 'expected-behavior',
                label: 'Expected behavior',
                kind: 'textarea',
                required: true,
            },
            {
                id: 'software-version',
                label: 'Software Version',
                kind: 'input',
                required: true,
                placeholder: '3.0.0 commit db1b0ee3b30f',
            },
            {
                id: 'operating-system',
                label: 'Operating system/version',
                kind: 'input',
                required: true,
                placeholder: 'Windows 11 Home',
            },
        ],
    },
    feature: {
        id: 'feature',
        name: 'Feature Request',
        titlePrefix: '✨ [Feature]: ',
        labels: ['Kind/Feature'],
        fields: [
            {
                label: 'Feature Request intro',
                kind: 'markdown',
                required: false,
                value: '## Feature Request\nUse this form to propose a new feature or capability.',
            },
            {
                id: 'summary',
                label: 'Summary',
                kind: 'input',
                required: true,
            },
            {
                id: 'problem-statement',
                label: 'Problem Statement',
                kind: 'textarea',
                required: true,
            },
            {
                id: 'proposed-solution',
                label: 'Proposed Solution',
                kind: 'textarea',
                required: true,
            },
            {
                id: 'alternatives',
                label: 'Alternatives Considered',
                kind: 'textarea',
                required: false,
            },
            {
                id: 'additional-context',
                label: 'Additional Context',
                kind: 'textarea',
                required: false,
            },
            {
                id: 'priority',
                label: 'Priority',
                kind: 'dropdown',
                required: true,
                options: ['Low', 'Medium', 'High', 'Urgent'],
            },
        ],
    },
    enhancement: {
        id: 'enhancement',
        name: 'Enhancement Request',
        titlePrefix: '⚙️ [Enhancement]: ',
        labels: ['Kind/Enhancement'],
        fields: [
            {
                label: 'Enhancement Request intro',
                kind: 'markdown',
                required: false,
                value: '## Enhancement Request\nUse this form to request improvements to an existing feature.',
            },
            {
                id: 'summary',
                label: 'Summary',
                kind: 'input',
                required: true,
            },
            {
                id: 'detailed-description',
                label: 'Detailed Description',
                kind: 'textarea',
                required: true,
            },
            {
                id: 'reason',
                label: 'Reason for Change',
                kind: 'textarea',
                required: true,
            },
            {
                id: 'priority',
                label: 'Priority',
                kind: 'dropdown',
                required: true,
                options: ['Low', 'Medium', 'High', 'Urgent'],
            },
        ],
    },
    documentation: {
        id: 'documentation',
        name: 'Documentation',
        titlePrefix: '📝 [Docs]: ',
        labels: ['Kind/Documentation'],
        fields: [
            {
                id: 'documentation-update',
                label: 'Documentation Update',
                kind: 'textarea',
                required: true,
            },
            {
                id: 'why-needed',
                label: 'Why Is This Needed?',
                kind: 'textarea',
                required: true,
            },
            {
                id: 'suggested-changes',
                label: 'Suggested Changes',
                kind: 'textarea',
                required: true,
            },
            {
                id: 'additional-context',
                label: 'Additional Context',
                kind: 'textarea',
                required: false,
            },
        ],
    },
    general: {
        id: 'general',
        name: 'General Report',
        titlePrefix: '[General]: ',
        labels: [],
        fields: [
            {
                id: 'feedback',
                label: 'Feedback or Inquiry',
                kind: 'textarea',
                required: true,
            },
            {
                id: 'additional-information',
                label: 'Additional Information',
                kind: 'textarea',
                required: false,
            },
        ],
    },
};
//# sourceMappingURL=issue-templates.js.map